import { Modal } from "react-bootstrap";
import Icons from "../myIcon/Icons";
import { BaseUrl } from "../helper/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Addpopup({ addPopShow, setAddPopShow, headingText, paraText, btnText }) {
    const navigate = useNavigate();
    const [ip, setIp] = useState("");
    const [loading, setLoading] = useState(false);

    const [postData, setPostData] = useState({ name: "", email: "", mobile: "", location: "", what_planning: "", when_start: "", messages: "", source_url: sessionStorage.getItem("first_landing_url"), ip_address: ip, });

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Name validation
        if (name === "name") {
            // Allow only alphabets and spaces
            const filteredValue = value.replace(/[^A-Za-z\s]/g, "");

            setPostData((prev) => ({
                ...prev,
                [name]: filteredValue,
            }));

            return;
        }

        // Mobile validation
        if (name === "mobile") {
            // Allow only numbers
            const filteredValue = value.replace(/\D/g, "");

            setPostData((prev) => ({
                ...prev,
                [name]: filteredValue,
            }));

            return;
        }

        setPostData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    useEffect(() => {
        // Get IP address on component load
        const fetchIp = async () => {
            const res = await fetch("https://api.ipify.org?format=json");
            const data = await res.json();
            setIp(data.ip);
        };
        fetchIp();
    }, []);

    // Submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();

        for (const [key, value] of Object.entries(postData)) {
            if (
                key !== "source_url" &&
                key !== "ip_address" &&
                (value === "" || value === null)
            ) {
                toast.error(`The field "${key}" is mandatory.`);
                return;
            }
        }

        if (!/^[A-Za-z\s]+$/.test(postData.name)) {
            toast.error("Name should contain only alphabets.");
            return;
        }

        if (!/^[0-9]+$/.test(postData.mobile)) {
            toast.error("Phone Number should contain only digits.");
            return;
        }

        if (postData.mobile.length !== 10) {
            toast.error("Phone Number should be exactly 10 digits long.");
            return;
        }

        const payload = {
            ...postData,
            ip_address: ip,
            source_url: sessionStorage.getItem("first_landing_url"),
        };

        setLoading(true);

        try {
            await axios.post(`${BaseUrl}/api/contact-saves`, payload);
            setAddPopShow();
            navigate("/thankyou");
            setPostData({ name: "", email: "", mobile: "", location: "", what_planning: "", when_start: "", messages: "", source_url: sessionStorage.getItem("first_landing_url"), ip_address: ip, });

        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal className="query-popup" show={addPopShow} onHide={() => setAddPopShow(false)} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    <button className="popup-close" onClick={() => setAddPopShow(false)}><Icons name="plus" /></button>
                    <div className="row m-0">
                        <div className="col-lg-7 col-md-7 no-padd">
                            <div className="query-formbox">
                                <h4 className="heading">{headingText || "Let’s talk about designing your space."} </h4>
                                <p>{paraText || "Fill in your details below & our expert will call you back."}</p>

                                <form onSubmit={handleSubmit}>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-6'>
                                            <div className="form-field">
                                                <input value={postData.name} onChange={handleChange} type="text" name="name" placeholder="Name*" required className="form-control" />
                                            </div>
                                        </div>

                                        <div className='col-lg-6 col-md-6'>
                                            <div className="form-field">
                                                <input value={postData.email} onChange={handleChange} name="email" type="email" placeholder="Email*" required className="form-control" />
                                            </div>
                                        </div>

                                        <div className='col-lg-6 col-md-6'>
                                            <div className="form-field">
                                                <input value={postData.mobile} onChange={handleChange} name="mobile" type="tel" maxLength={10} placeholder="Phone*" required className="form-control" />
                                            </div>
                                        </div>

                                        <div className='col-lg-6 col-md-6'>
                                            <div className="form-field">
                                                <input value={postData.location} onChange={handleChange} type="text" name="location" placeholder="City*" required className="form-control" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-field">
                                        <select className='form-control' value={postData.what_planning} onChange={handleChange} required name="what_planning" >
                                            <option value="" disabled>What Are You Planning?</option>
                                            <option value="New home kitchen">New home kitchen</option>
                                            <option value="Kitchen renovation">Kitchen renovation</option>
                                            <option value="Wardrobe">Wardrobe</option>
                                            <option value="Full home interiors">Full home interiors</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>

                                   <div className="form-field">
                                        <select className='form-control' value={postData.when_start} onChange={handleChange} required name="when_start" >
                                            <option value="" disabled>When Are You looking to start?</option>
                                            <option value="Within 1 month">Within 1 month</option>
                                            <option value="1-3 months">1-3 months</option>
                                            <option value="3-6 months">3-6 months</option>
                                            <option value="Just exploring">Just exploring</option>
                                        </select>
                                   </div>

                                    <div className="form-field">
                                        <textarea value={postData.messages} onChange={handleChange} name="messages" placeholder="Your Message" className="form-control" />
                                    </div>

                                    <div>
                                        <button type="submit" className="default-btn colored-btn">
                                            {loading ? "submitting..." : btnText || "Book a consultation now"} <Icons name="Longarrow_right" />
                                        </button>
                                    </div>

                                    <ul className="addconsult-points">
                                        <li><img src="/image/star-icon.webp" alt="star"/>Direct Manufacturer</li>
                                        <li><img src="/image/star-icon.webp" alt="star"/>No Middleman Cost</li>
                                        <li><img src="/image/star-icon.webp" alt="star"/>Gurgaon Based</li>
                                    </ul>
                                </form>
                            </div>
                        </div>

                        <div className="col-lg-5 col-md-5 no-padd">
                            <div className="querypop-image">
                                <img src="/image/query-image.webp" alt="query" className="img-responsive" />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
